/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AddressClassification {
  COMMERCIAL = 'COMMERCIAL',
  MILITARY = 'MILITARY',
  RESIDENTIAL = 'RESIDENTIAL',
  UNKNOWN = 'UNKNOWN',
}

export enum AddressHomeSize {
  four_bed_plus = 'four_bed_plus',
  one_bed = 'one_bed',
  studio = 'studio',
  three_bed = 'three_bed',
  three_bed_plus = 'three_bed_plus',
  two_bed = 'two_bed',
}

export enum AddressOwnership {
  OWN = 'OWN',
  RENT = 'RENT',
}

export enum AddressStatus {
  APT_NEEDED = 'APT_NEEDED',
  INVALID = 'INVALID',
  VALID = 'VALID',
}

export enum Direction {
  move_in = 'move_in',
  move_out = 'move_out',
  transfer = 'transfer',
  unknown = 'unknown',
}

export enum DivisionUtilitiesConfigProofFormat {
  account_number = 'account_number',
  document = 'document',
  number = 'number',
}

/**
 * Move size values supported by dolly. This does not necessarily match AddressHomeSize.
 */
export enum DollyMoveSize {
  one_bed = 'one_bed',
  studio = 'studio',
  three_bed = 'three_bed',
  two_bed = 'two_bed',
}

export enum HomeServicesCallCenter {
  bridgevine = 'bridgevine',
  kandela = 'kandela',
}

export enum HomeServicesFlowPreference {
  EXCLUSIVE = 'EXCLUSIVE',
  FEATURED = 'FEATURED',
  SHOP = 'SHOP',
  TRANSFER = 'TRANSFER',
}

export enum HomeServicesProviderFeaturedKind {
  property_exclusive = 'property_exclusive',
  property_featured = 'property_featured',
  updater_featured = 'updater_featured',
}

export enum HomeServicesReservationStatus {
  RESERVED = 'RESERVED',
}

export enum InternetKind {
  BPL = 'BPL',
  CABLE = 'CABLE',
  DSL = 'DSL',
  FIBER = 'FIBER',
  SATELLITE = 'SATELLITE',
  WIRELESS = 'WIRELESS',
}

export enum InternetProductType {
  bpl = 'bpl',
  cable = 'cable',
  dsl = 'dsl',
  fiber = 'fiber',
  satellite = 'satellite',
  wireless = 'wireless',
}

export enum InternetSpeedTier {
  MAXIMUM = 'MAXIMUM',
  MINIMUM = 'MINIMUM',
  NORMAL = 'NORMAL',
}

export enum InviteStatus {
  ANSWERED = 'ANSWERED',
  BOUNCED = 'BOUNCED',
  CANCELLED = 'CANCELLED',
  CLAIMED = 'CLAIMED',
  DUPLICATE = 'DUPLICATE',
  EMAIL_REQUESTED = 'EMAIL_REQUESTED',
  INFO_NEEDED = 'INFO_NEEDED',
  INVALID_EMAIL = 'INVALID_EMAIL',
  NOT_SENT = 'NOT_SENT',
  OPENED = 'OPENED',
  OPT_OUT = 'OPT_OUT',
  QUEUED_TO_MOVER = 'QUEUED_TO_MOVER',
  REJECTED = 'REJECTED',
  REQUEUED_TO_MOVER = 'REQUEUED_TO_MOVER',
  RESENT_TO_MOVER = 'RESENT_TO_MOVER',
  REVIEW = 'REVIEW',
  REVIEWED = 'REVIEWED',
  SENT_TO_MOVER = 'SENT_TO_MOVER',
}

export enum LocationType {
  area = 'area',
  building = 'building',
}

export enum OfferValueTier {
  BAD = 'BAD',
  GOOD = 'GOOD',
  OK = 'OK',
}

export enum PhoneKind {
  CABLE = 'CABLE',
  FIBER = 'FIBER',
  LANDLINE = 'LANDLINE',
  SATELLITE = 'SATELLITE',
  VOIP = 'VOIP',
}

export enum PhoneProductType {
  cable = 'cable',
  fiber = 'fiber',
  landline = 'landline',
  satellite = 'satellite',
  voip = 'voip',
}

export enum PhoneVerificationMethodInput {
  CALL = 'CALL',
  SMS = 'SMS',
}

export enum ServiceabilityCachingStrategy {
  aggressive = 'aggressive',
  conservative = 'conservative',
  none = 'none',
}

export enum ServiceabilityChargeType {
  activation = 'activation',
  early_cancellation = 'early_cancellation',
  installation = 'installation',
  long_term = 'long_term',
  short_term = 'short_term',
}

export enum ServiceabilityDisclaimerDisplayLocation {
  details = 'details',
  list_page = 'list_page',
  proximity = 'proximity',
}

export enum ServiceabilityInternetSpeedUnit {
  gbps = 'gbps',
  kbps = 'kbps',
  mbps = 'mbps',
}

export enum ServiceabilityProviderAvailability {
  available = 'available',
  unavailable = 'unavailable',
  unknown = 'unknown',
}

export enum ServiceabilityResultStatus {
  cache = 'cache',
  error = 'error',
  ok = 'ok',
}

export enum ServiceabilityTermUnit {
  month = 'month',
  year = 'year',
}

export enum Statuses {
  cancelled = 'cancelled',
  completed = 'completed',
  info_requested = 'info_requested',
  started = 'started',
  validating = 'validating',
}

export enum SubscriptionPreferencesChannel {
  email_marketing = 'email_marketing',
}

export enum SubscriptionPreferencesMessage {
  abandonment = 'abandonment',
  invite = 'invite',
  lifecycle = 'lifecycle',
  promotional = 'promotional',
  survey = 'survey',
}

export enum TvKind {
  CABLE = 'CABLE',
  FIBER = 'FIBER',
  IPTV = 'IPTV',
  SATELLITE = 'SATELLITE',
}

export enum TvPackage {
  FAMILY = 'FAMILY',
  LATINO = 'LATINO',
  NEWS = 'NEWS',
  PREMIUM = 'PREMIUM',
  SPORTS = 'SPORTS',
}

export enum TvProductType {
  cable = 'cable',
  fiber = 'fiber',
  iptv = 'iptv',
  satellite = 'satellite',
}

export enum UtilityKinds {
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  WATER = 'WATER',
  electric = 'electric',
  gas = 'gas',
  water = 'water',
}

export enum UtilityMatchLevel {
  POSTALCODE = 'POSTALCODE',
  PROPERTY = 'PROPERTY',
}

export enum VerifyPinUserFieldInput {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export interface AdditionalInsuredInput {
  firstName: string;
  lastName: string;
}

export interface AddressInput {
  unit?: string | null;
  street: string;
  city: string;
  state: string;
  postalCode: string;
  homeSize?: AddressHomeSize | null;
}

export interface AnswerInviteInput {
  token: string;
}

/**
 * moveId or address required with address taking precedence.
 */
export interface AvailableOffersInput {
  moveId?: string | null;
  address?: AddressInput | null;
  providerCodes?: string[] | null;
  cachingStrategy?: ServiceabilityCachingStrategy | null;
  requestId?: string | null;
  suggestedAddressSelections?:
    | ServiceabilitySuggestedAddressSelections[]
    | null;
  source?: string | null;
}

/**
 * moveId or address required with address taking precedence.
 */
export interface AvailableProductsInput {
  moveId?: string | null;
  address?: AddressInput | null;
  providerCodes?: string[] | null;
  cachingStrategy?: ServiceabilityCachingStrategy | null;
  requestId?: string | null;
  suggestedAddressSelections?:
    | ServiceabilitySuggestedAddressSelections[]
    | null;
  shopFlowVersions?: (string | null)[] | null;
}

export interface AvailableUtilityProviderAddress {
  id?: string | null;
  street?: string | null;
  unit?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
}

export interface AvailableUtilityProviderFilter {
  enabled?: boolean | null;
  matchLevel?: UtilityMatchLevel | null;
}

export interface AvailableUtilityProviderInput {
  divisionId?: string | null;
  address?: AvailableUtilityProviderAddress | null;
  filter?: AvailableUtilityProviderFilter | null;
}

export interface CancelInviteInput {
  token: string;
}

export interface ChangePasswordInput {
  pwChangeToken: string;
  newPassword: string;
}

export interface CreateItemInput {
  kind: string;
  status?: Statuses | null;
  metadata?: any | null;
  userUuid?: string | null;
}

export interface DollyEligibilityInput {
  addresses: AddressInput[];
  moveDateRange?: any[] | null;
  moveSize?: DollyMoveSize | null;
}

export interface DollyMoveInput {
  moveId: string;
  toAddress: AddressInput;
  fromAddress: AddressInput;
  moveDate: any;
}

export interface EmailAvailableInput {
  email: string;
  inviteToken?: string | null;
}

export interface HomeServiceReservationUserInput {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface HomeServicesAddressInput {
  unit?: string | null;
  street: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface HomeServicesBridgevineMetadataInput {
  sessionId: string;
  transactionId: string;
}

export interface HomeServicesCallCenterInput {
  name: HomeServicesCallCenter;
  outbound?: boolean | null;
}

export interface HomeServicesMetadataInput {
  bridgevine?: HomeServicesBridgevineMetadataInput | null;
  checkoutEnabled?: boolean | null;
}

export interface HomeServicesOfferInput {
  id: string;
  code: string;
  name: string;
  price?: number | null;
  term: string;
  valueScore?: number | null;
  valueTier?: OfferValueTier | null;
  provider: HomeServicesProviderInput;
  services: HomeServicesOfferServicesInput;
  promo?: HomeServicesOfferPromoInput | null;
  introductoryPrice?: HomeServicesOfferIntroductoryPriceInput | null;
  promotions?: (HomeServicesOfferPromotionInput | null)[] | null;
  disclaimer?: string | null;
  highlights?: (string | null)[] | null;
  extendedHighlights?: (string | null)[] | null;
  proximityDisclaimer?: ProximityDisclaimerInput | null;
  metadata?: any | null;
  tags?: (string | null)[] | null;
}

export interface HomeServicesOfferIntroductoryPriceInput {
  price?: number | null;
  term?: string | null;
  duration?: number | null;
  savingsPercent?: number | null;
}

export interface HomeServicesOfferPromoInput {
  price?: number | null;
  term?: string | null;
  duration?: number | null;
  savingsPercent?: number | null;
}

export interface HomeServicesOfferPromotionInput {
  promotion?: string | null;
  disclaimer?: string | null;
}

export interface HomeServicesOfferServicesInput {
  internet?: InternetServiceInput | null;
  tv?: TvServiceInput | null;
  phone?: PhoneServiceInput | null;
}

export interface HomeServicesPreferencesInput {
  internet: InternetPreferenceInput;
  tv: TvPreferenceInput;
  phone: PhonePreferenceInput;
  flow?: HomeServicesFlowPreference | null;
  updaterPropertyConfig?: HomeServicesPropertyConfigInput | null;
  propertyConfig?: HomeServicesPropertyConfigInput | null;
}

export interface HomeServicesPropertyConfigInput {
  allowSatellite?: boolean | null;
  providers?: (HomeServicesProviderInput | null)[] | null;
}

export interface HomeServicesProviderInput {
  id: string;
  name?: string | null;
  logo?: string | null;
  featured?: boolean | null;
  exclusive: boolean;
  featuredKind?: HomeServicesProviderFeaturedKind | null;
}

export interface InternetPreferenceInput {
  speed?: InternetSpeedTier | null;
  serviceRequired?: boolean | null;
}

export interface InternetServiceInput {
  speed?: InternetSpeedInput | null;
  kind?: InternetKind | null;
}

export interface InternetSpeedInput {
  mbps: number;
  tier: InternetSpeedTier;
}

export interface MakeHomeServicesOrderInput {
  moveId: string;
  reservationCode: string;
  offer: HomeServicesOfferInput;
  contactInformation?: any | null;
  creditCheck?: any | null;
  security?: any | null;
  installation?: any | null;
  optIns?: any | null;
  promotionOptions?: any | null;
  payment: any;
  price: any;
}

export interface MakeHomeServicesReservationInput {
  checkoutEnabled?: boolean | null;
  moveId: string;
  offer: HomeServicesOfferInput;
  offers?: (HomeServicesOfferInput | null)[] | null;
  preferences: HomeServicesPreferencesInput;
  propertyConfig?: HomeServicesPropertyConfigInput | null;
  callCenter?: HomeServicesCallCenterInput | null;
  metadata?: HomeServicesMetadataInput | null;
  user?: HomeServiceReservationUserInput | null;
  toAddress?: HomeServicesAddressInput | null;
  fromAddress?: HomeServicesAddressInput | null;
}

export interface MoveAddKeyInput {
  uuid: string;
  inviteToken?: string | null;
  key: string;
  value: string;
}

export interface MoveAddressInput {
  unit?: string | null;
  street: string;
  city: string;
  state: string;
  postalCode: string;
  homeSize?: AddressHomeSize | null;
  ownership?: AddressOwnership | null;
}

export interface MoveFindKeyInput {
  uuid: string;
  inviteToken?: string | null;
  key: string;
}

export interface MoveMetadataInput {
  personalization?: MovePersonalizationInput | null;
}

export interface MovePersonalizationInput {
  movingReason?: string | null;
  personsMoving?: string[] | null;
}

export interface PhonePreferenceInput {
  landline?: boolean | null;
  serviceRequired?: boolean | null;
}

export interface PhoneServiceInput {
  kind?: PhoneKind | null;
}

export interface ProximityDisclaimerInput {
  proximityDisclosure?: string | null;
  pricingText?: string | null;
}

export interface ServiceabilityReservationInput {
  moveId: string;
  products: any;
  metadata?: ServiceabilityReservationMetadata | null;
}

export interface ServiceabilityReservationMetadata {
  checkoutEnabled?: boolean | null;
}

export interface ServiceabilitySuggestedAddressSelections {
  providerCode?: string | null;
  providerAddressId: string;
}

export interface SigninInput {
  email: string;
  password: string;
  sessionLength?: number | null;
}

export interface SignupMoveAddressInput {
  unit?: string | null;
  street: string;
  city: string;
  state: string;
  postalCode: string;
  homeSize?: AddressHomeSize | null;
  ownership?: AddressOwnership | null;
  status?: AddressStatus | null;
  classification?: AddressClassification | null;
  components?: string | null;
  analysis?: string | null;
  metadata?: string | null;
}

export interface SignupMoveInput {
  externalId?: string | null;
  moveDate: any;
  fromAddress: SignupMoveAddressInput;
  toAddress: SignupMoveAddressInput;
  metadata?: MoveMetadataInput | null;
  sessionLength?: number | null;
}

export interface SignupMoverInput {
  inviteToken?: string | null;
  referralCode?: string | null;
  move: SignupMoveInput;
  mover: SignupUserInput;
  promotions?: string[] | null;
}

export interface SignupUserInput {
  externalId?: string | null;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  suffixName?: string | null;
  email: string;
  phone?: string | null;
  password: string;
  metadata?: UserMetadataInput | null;
}

export interface SiteBrandingInput {
  inviteToken?: string | null;
  subdomain?: string | null;
}

export interface SubmitItemAnswerInput {
  itemId: number;
  submission: any;
  utilityKind?: UtilityKinds | null;
  finalSubmit?: boolean | null;
}

export interface SubscriptionFindPreferencesInput {
  inviteToken?: string | null;
  userUuid?: string | null;
}

export interface SubscriptionPreferencesInput {
  channel: SubscriptionPreferencesChannel;
  messageType: SubscriptionPreferencesMessage;
  subscribe: boolean;
}

export interface SubscriptionUpsertPreferencesInput {
  inviteToken?: string | null;
  userUuid?: string | null;
  subscriptionPreferences: SubscriptionPreferencesInput[];
}

export interface TvChannelsInput {
  count: number;
}

export interface TvFeaturesInput {
  onDemand?: boolean | null;
  dvr?: boolean | null;
}

export interface TvNetworksInput {
  cinemax?: boolean | null;
  hbo?: boolean | null;
  showtime?: boolean | null;
  starz?: boolean | null;
}

export interface TvPreferenceInput {
  packages?: (TvPackage | null)[] | null;
  cable?: boolean | null;
  serviceRequired?: boolean | null;
}

export interface TvServiceInput {
  kind?: TvKind | null;
  channels?: TvChannelsInput | null;
  networks?: TvNetworksInput | null;
  features?: TvFeaturesInput | null;
  additionalLanguages?: (string | null)[] | null;
  shortDescription?: string | null;
  longDescription?: string | null;
}

export interface UpdateMoveInput {
  id?: string | null;
  externalId?: string | null;
  toAddress?: MoveAddressInput | null;
  fromAddress?: MoveAddressInput | null;
  date?: any | null;
}

/**
 * Update user identified by id, externalId, otherwise the current user.
 */
export interface UpdateUserInput {
  id?: string | null;
  externalId?: string | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  email?: string | null;
  phone?: string | null;
  onboardingCompleted?: boolean | null;
  phoneVerificationMethod?: PhoneVerificationMethodInput | null;
}

export interface UserMetadataInput {
  preferences?: UserPreferencesInput | null;
}

export interface UserPreferencesInput {
  allowCall?: boolean | null;
}

export interface VerifyPinInput {
  userField: VerifyPinUserFieldInput;
  pin: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
